module.exports = __webpack_public_path__ + "static/media/active_status_card.43193ab3.svg";